import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";

import LoadingComponent from "../../app/layout/LoadingComponent";
import { getCATCursos } from '../../app/models/CATCursos';
import { Botonera } from '../Portafolio/helpers/botonera';
import { useStore } from "../../app/stores/store";

import { AnchorTabsCertificaciones } from "../Portafolio/Handlers/AnchorTabs";
import { BuscadorComponent } from "../Portafolio/BuscadorCursos/BuscadorComponent";
import { calculoFechas } from "../Portafolio/helpers/calculoFechas";

//import banner from "../../images/Certificaciones.jpg";
import Footer from "../Footer";

import icon_person from '../Portafolio/src/imgs/person_icon.svg';
import icon_teacher from '../Portafolio/src/imgs/teacher_icon.svg';
import icon_calendar from '../Portafolio/src/imgs/calendar_icon.svg';
import { RegionalBannerPeten } from '../Portafolio/Handlers/RegionalBannerPeten';
import { AnchorTabsCategories } from "../Portafolio/Handlers/AnchorTabsCategories";

export default observer(function Cursos() {

  const { userStore: { user } } = useStore();
  const { CATCursosStore } = useStore();
  const { CATCursosRegistry, loadCATCursosByLevel, getCATCursosByLevel } = CATCursosStore;

  useEffect(() => {
    if (CATCursosRegistry.size <= 1) {
      loadCATCursosByLevel("111", "2");
      loadCATCursosByLevel("122", "2");
      loadCATCursosByLevel("133", "2");
    }
  }, [CATCursosRegistry.size, loadCATCursosByLevel]);

  if (CATCursosStore.loadingInitial)

    return <LoadingComponent content="Cargando datos.." />;
  return (
    
    <>
      <RegionalBannerPeten />
{/*       
      <div className="banner_area container-fluid">
        <div className="banner_top">
          <img src={banner}></img>
        </div>
      </div> */}

      <AnchorTabsCertificaciones/>
      <AnchorTabsCategories />
      
      <div className="portafolio_phome_area catalogo_servicios">

        <div className="portafolio_header">
        <Botonera/>
          <div className="buscador_area">
            <BuscadorComponent />
          </div>
        </div>

        <div id="section1" className="portafolio_htexto">
          <p>Se extiende de forma conjunta por el INAP y la Oficina Nacional de Servicio Civil -ONSEC-. La certificación acredita que el funcionario y servidor público posea las calidades y conocimientos, referentes a la Administración Publica, en los tres niveles establecidos: Básico, Intermedio y Avanzado.</p>
        </div>
    
        <div id="hw_search" className="portafolio_subcat first_section">
          <h2>Certificación Básica</h2>
        </div>
    

        <div id="hw_search" className="portafolio_content">

          {getCATCursosByLevel.map((item) => {

            const url = `/asesoria/${item.id}/${user?.id}`,
                  startDateFrom = new Date( item.editions[0]?.fechaDeInicioInscripcion );

            if (
              item.nivel === "111" && item.editions[0]?.is_active === true
            ) {
              return (

                <>

                  <div className="portafolio_card"
                  
                  >

                    <Link to={url}
                   
                    >

                      <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                      <div className="pcard_tipoc"> <p className="mod_card_basica">{item.modalidad}</p></div>

                      <div className="pcard_contenido_publico">
                        <div className="pcard_edicion">
                          <p>-Edición en curso {item.editions[0]?.numeroEdicion}</p>
                        </div>

                        <div className="pcard_titulo_curso">
                          <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                        </div>

                        <div className="card_info_curso">
                          <div className="pcard_estudiantes">
                            <img src={icon_person} />
                            <p>Inicio de inscripciones</p>
                          </div>
                          <div className="pcard_fecha">
                            <img src={icon_calendar} />
                            <p> {calculoFechas( startDateFrom )} </p>
                          </div>
                        </div>

                        <div className="pcard_docentes">
                          <img src={icon_teacher} />
                          <p>Lic. {item.editions[0]?.catedratico}</p>
                        </div>

                      </div>

                      <div className="pcard_linea"><span></span></div>

                    </Link>

                  </div>

                </>


              );
            }
          })}

        </div>
     
          <div id="section2" className="portafolio_subcat second_section">
            <h2>Certificación Intermedia</h2>
          </div>

        <div id="hw_search" className="portafolio_content">

          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {

            const url = `/asesoria/${item.id}/${user?.id}`,
                  startDateFrom = new Date( item.editions[0]?.fechaDeInicioInscripcion );

            if (
              item.nivel == "122" && item.editions[0]?.is_active === true
            ) {
              return (

                <>

                  <div className="portafolio_card">

                    <Link to={url}>

                      <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                      <div className="pcard_tipoc"> <p className="mod_card_intermedia">{item.modalidad}</p></div>

                      <div className="pcard_contenido_publico">
                        <div className="pcard_edicion">
                          <p>-Edición en curso {item.editions[0]?.numeroEdicion}</p>
                        </div>

                        <div className="pcard_titulo_curso">
                          <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                        </div>

                        <div className="card_info_curso">
                          <div className="pcard_estudiantes">
                            <img src={icon_person} />
                            <p>Inicio de inscripciones</p>
                          </div>
                          <div className="pcard_fecha">
                            <img src={icon_calendar} />
                            <p> {calculoFechas( startDateFrom )} </p>
                          </div>
                        </div>

                        <div className="pcard_docentes">
                          <img src={icon_teacher} />
                          <p>Lic. {item.editions[0]?.catedratico}</p>
                        </div>

                      </div>

                      <div className="pcard_linea"><span></span></div>

                    </Link>

                  </div>

                </>


              );
            }
          })}

        </div>
    
          <div id="section3" className="portafolio_subcat fourth_section">
            <h2>Certificación Avanzada</h2>
          </div>

        <div className="portafolio_content">

          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {

            const url = `/asesoria/${item.id}/${user?.id}`,
                  startDateFrom = new Date( item.editions[0]?.fechaDeInicioInscripcion );

            if (
              item.nivel == "133" && item.editions[0]?.is_active === true
            ) {
              return (

                <>

                  <div id="hw_search" className="portafolio_card">

                    <Link to={url}>

                      <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                      <div className="pcard_tipoc"> <p className="mod_card_avanzada">{item.modalidad}</p></div>

                      <div className="pcard_contenido_publico">
                        <div className="pcard_edicion">
                          <p>-Edición en curso {item.editions[0]?.numeroEdicion}</p>
                        </div>

                        <div className="pcard_titulo_curso">
                          <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                        </div>

                        <div className="card_info_curso">
                          <div className="pcard_estudiantes">
                            <img src={icon_person} />
                            <p>Inicio de inscripciones</p>
                          </div>
                          <div className="pcard_fecha">
                            <img src={icon_calendar} />
                            <p> {calculoFechas( startDateFrom )} </p>
                          </div>
                        </div>

                        <div className="pcard_docentes">
                          <img src={icon_teacher} />
                          <p>Lic. {item.editions[0]?.catedratico}</p>
                        </div>

                      </div>

                      <div className="pcard_linea"><span></span></div>

                    </Link>

                  </div>

                </>


              );
            }
          })}

        </div>

      </div>

      <Footer />

    </>

  );
});
